import React, { FC } from 'react';
import { ToastProps } from 'react-toast-notifications';

const Snackbar: FC<ToastProps> = ({ transitionDuration, transitionState, onDismiss, children }) => {
  return (
    <div
      className={`snackebar snackebar--${transitionState}`}
      style={{ transitionDuration: `${transitionDuration}ms` }}
    >
      <div className='snackebar__content'>{children}</div>
      <div role='button' className='snackebar__action' onClick={() => onDismiss()}>
        Close
      </div>
    </div>
  );
};

export default Snackbar;
